module.exports = __webpack_public_path__ + "images/cebsblogo_white.1790230608476.png";